import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { TeamData } from 'types/fpl/teams'
import type { UserInitialState } from 'types/store/user'

export const userInitialState: UserInitialState = {
  teamData: null
}

export const userSlice = createSlice({
  name: 'user',
  initialState: userInitialState,
  reducers: {
    setTeamData: (state, action: PayloadAction<TeamData>): void => {
      state.teamData = action.payload
    },
    clearTeamData: (state): void => {
      state.teamData = null
    },
  }
})

export const { setTeamData, clearTeamData } = userSlice.actions

export default userSlice.reducer
